// extracted by mini-css-extract-plugin
export default {"back-button":"BackButton__back-button__tGiDz","backButton":"BackButton__back-button__tGiDz"};